
import { Component, Vue } from "vue-property-decorator";
import { Request } from "@/interfaces";
import {
  dispatchGetRequests,
  dispatchGetRequestStates,
  dispatchGetRequestPassportImage,
  dispatchRequestCreateAccount,
  dispatchDeleteRequest,
  dispatchGetProjects,
  dispatchGetArchive,
} from "@/store/main/actions";
import {
  readOneRequest,
  readRequestStateName,
  readImage,
  readHasAdminAccess,
  readOneProject,
} from "@/store/main/getters";
import { dispatchGetUsers } from "@/store/admin/actions";
import store from "@/store";

@Component
export default class ShowRequest extends Vue {
  public valid = true;
  public loading = true;
  public recieptImageUrl = "";
  public project_name = "";
  public project: any = null;
  public fields = {};
  public fields_array = [];

  public request: Request | null = null;

  public admin = readHasAdminAccess(store);

  public async mounted() {
    this.loading = true;
    const promises = [
      dispatchGetRequests(this.$store),
      dispatchGetArchive(this.$store),
      dispatchGetRequestStates(this.$store),
      dispatchGetProjects(this.$store),
      dispatchGetRequestPassportImage(this.$store, {
        requestId: +this.$router.currentRoute.params.id,
      }),
    ];
    if (readHasAdminAccess(this.$store)) this.admin = true;
    if (this.admin) {
      promises.push(dispatchGetUsers(this.$store));
    }
    await Promise.allSettled(promises);
    this.recieptImageUrl = "";
    const request = readOneRequest(this.$store)(
      +this.$router.currentRoute.params.id
    );

    console.log(request);

    if (request) this.request = request;

    this.project = readOneProject(this.$store)(this.request?.project_id!);
    this.project_name = this.project?.id + "-" + this.project?.name;

    const blob = readImage(this.$store);
    if (blob) {
      const result = await this.readImage(blob);
      if (typeof result === "string") {
        this.recieptImageUrl = result;
      }
    }

    this.fields = this.project!.request_fields;
    for (const field in this.project!.request_fields) {
      if (typeof this.project!.request_fields[field] === "string") {
        const property = this.project!.request_fields[field].split("+")[0];
        this.fields[field] = {
          id: +this.project!.request_fields[field].split("+")[1],
          required: property == "required",
          hidden: property == "hidden",
          type: "string",
          default: "",
        };
      } else if (typeof this.project!.request_fields[field] === "number") {
        this.fields[field] = {
          id: this.project!.request_fields[field],
          required: true,
          hidden: false,
          type: "line",
          default: "",
        };
      }
      if (this.fields[field]["type"] === "str") {
        this.fields[field]["type"] = "string";
      } else if (this.fields[field]["type"] === "int") {
        this.fields[field]["type"] = "number";
      }
    }
    const fields_array = Object.keys(this.fields)
      .map((key) => [key, this.fields[key]])
      .sort((one, two) => one[1].id - two[1].id);
    this.fields_array.push([]);
    for (const field in fields_array) {
      if (fields_array[field][1].type === "line") this.fields_array.push([]);
      this.fields_array.at(-1)!.push(fields_array[field]);
    }

    this.loading = false;
  }

  public cancel() {
    this.$router.back();
  }

  public async edit() {
    this.$router.push({
      name: "main-request-edit",
      params: { id: this.$router.currentRoute.params.id },
    });
  }
  public async delete_request() {
    this.$confirm({
      auth: false,
      message: "delete this request?",
      button: {
        yes: "Yes",
        no: "Cancel",
      },
      /**
       * Callback Function
       * @param {Boolean} confirm
       */
      callback: async (confirm) => {
        if (confirm) {
          await dispatchDeleteRequest(this.$store, {
            id: this.request!.id,
          });
          this.$router.push("/main/request");
        }
      },
    });
  }
  public async settle() {
    this.$router.push({
      name: "main-request-settle",
      params: { id: this.$router.currentRoute.params.id },
    });
  }

  public async create_account() {
    await dispatchRequestCreateAccount(this.$store, {
      id: this.request!.id,
    });
  }

  get state() {
    const state_id = readOneRequest(this.$store)(
      +this.$router.currentRoute.params.id
    )?.state;
    if (!state_id) return "----";
    return readRequestStateName(this.$store)(state_id);
  }

  public getColor() {
    if (this.state === "COMPLETED" || this.state === "APPLIED")
      return "color:green";
    else if (this.state === "NOT_CREATED" || this.state === "FAILED")
      return "color:red";
    return "color:blue";
  }

  public readImage(image_blob: Blob) {
    return new Promise<string | ArrayBuffer | null>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(image_blob);
    });
  }

  public async showPassport() {
    if (!this.request?.passport_number) return;
  }
}
